// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1OX_Z","info":"PatientInfo_info__2vdEb"};